import React from 'react';

const WhatsAppButton = () => {
  const phoneNumber = '13346205530'; // +52 1 33 4620 5530 (cell format for MX)
  const message = 'Hola, me interesa participar en la Carrera Ciclista por los Senderos del Mando. ¿Podrían darme más información?';

  const handleWhatsAppClick = () => {
    const url = `https://wa.me/52${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <button 
      className="whatsapp-button"
      onClick={handleWhatsAppClick}
      title="Contactar por WhatsApp"
    >
      <span>📱</span>
      WhatsApp
    </button>
  );
};

export default WhatsAppButton;
